module.exports = __webpack_public_path__ + "img/more_vert.30c6e4dd.svg";